import axios from 'axios';
import * as headerBlock from '../header/';
import Autocomplete from '../autocomplete/vue-autocomplete.vue';
import AreaCheckbox from '../areaCheckbox/';
import Thumbnail from '../thumbnail';
import Uploading from '../uploading';

const alert = require('vue-strap').alert;
const spinner = require('vue-strap').spinner;

export default {
  name: 'checklist-config',
  components: { headerBlock, Autocomplete, AreaCheckbox, alert, spinner, Thumbnail, Uploading },
  props: [
    'onLogout',
    'access_token',
    'authUser',
    'duplicate',
  ],
  mounted() {

  },
  data() {
    return {
      formData: {
        id: null,
        name: '',
        picture: '',
        picture_url: '',
        role: 'basic',
        area: [],
        double_signature_required: false,
        tasks: [],
      },
      activeTask: null,
      activeTaskNext: null,
      showTasks: true,
      emptyTask: {
        id: null,
        name: '',
        description: '',
        selectedContent: '',
        picture: '',
        picture_url: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        thumbnail_url: null,
        video_require: false,
        description_file: '',
        description_file_url: '',
        steps: [],
        stepsMustDelete: [],
        index: 0,
      },
      emptyStep: {
        id: null,
        order: 1,
        description: '',
        valid: true,
        picture_urlChanged: false,
        selectedContent: '',
        picture: '',
        picture_url: '',
        video: '',
        video_url: '',
        video_thumbnail: '',
        thumbnail_url: null,
        video_require: false,
      },
      suggestArea: [],
      userRoles: [],
      areas: [],
      checklist: null,
      checklistId: null,
      processLoading: false,
      areaFromList: false,
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Checklists',
          to: `${process.env.START_URL}/constructor/Checklists`,
        }, {
          text: 'Constructor',
          active: true,
        },
      ],
      haveItemChanges: false,
      needFill: false,
      hasSaveError: false,
      alertError: {
        text: 'Some fields are not filled',
        title: 'Error!',
        visible: false,
      },
      alertSuccess: {
        text: 'Saved successfully',
        title: 'Well Done!',
        visible: false,
      },
      upload: {
        total: 1,
        uploaded: 0,
        image: true,
        visible: false,
      },
      dragSrcEl: null,
    };
  },
  methods: {
    handleVideoFileChange(e) {
      if (e.target.files && e.target.files[0] && e.target.files[0].size > 50000000) {
        e.target.value = '';
        this.alertError.text = 'Maximum allowed video size is 50 MB.';
        this.alertError.visible = true;
        return;
      }
    },
    addEmptyStep(task) {
      let maxStepOrder = 0;
      const self = this;
      const orders = [];
      let orderCount = 1;
      for (let i = 0; i < task.steps.length; i++) {
        orders.push(+task.steps[i].order);
        if (maxStepOrder < task.steps[i].order) {
          maxStepOrder = task.steps[i].order;
        }
      }
      for (let i = 1; i <= +maxStepOrder + 1; i++) {
        if (orders.indexOf(i) === -1) {
          orderCount = i;
          break;
        }
      }
      task.steps.push(JSON.parse(JSON.stringify(self.emptyStep)));
      task.steps[task.steps.length - 1].order = orderCount;
    },
    addEmptyTask() {
      this.formData.tasks.push(JSON.parse(JSON.stringify(this.emptyTask)));
      // this.addEmptyStep(this.formData.tasks[this.formData.tasks.length - 1]);
      console.log('add task', this.formData.tasks);
      if (this.activeTask === null) {
        this.activeTask = 0;
      }
    },
    removeStep(task, index) {
      if (task.steps[index].id) {
        task.stepsMustDelete.push(task.steps[index].id);
      }
      task.steps.splice(index, 1);
    },
    processJSON(json) {
      return json.results;
    },
    getDataSearchArea(data, area) {
      this.formData.area = [area.area];
    },
    getUserAreaPath(area) {
      const result = [];
      for (let i = 0; i < area.length; i++) {
        const res = this.getUserAreaPath(area[i].subareas);
        for (let j = 0; j < res.length; j++) {
          result.push({ name: `${area[i].name}/${res[j].name}`, area: res[j].area });
        }
        if (res.length === 0) {
          result.push({ name: area[i].name, area: area[i] });
        }
      }
      return result;
    },
    updateSuggestArea() {
      this.suggestArea = [];
      const areaPaths = this.getUserAreaPath(this.areas);
      for (let i = 0; i < areaPaths.length; i++) {
        this.suggestArea.push(areaPaths[i]);
      }
    },
    clearChecklistItemVideo(e, step, index) {
      if (step.video_url) {
        step.video_url = '';
        this.$refs.checklistItemVideoFile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.checklistItemVideoFile[index].reset();
      e.preventDefault();
    },
    clearStepVideo(e, step, index) {
      if (step.video_url) {
        step.video_url = '';
        this.$refs.stepvideofile[index].reset();
        e.preventDefault();
        return;
      }
      if (!step.video) {
        return;
      }
      this.$refs.stepvideofile[index].reset();
      e.preventDefault();
    },
    clearPdfFile(e, index) {
      if (this.formData.tasks[index].description_file_url) {
        this.formData.tasks[index].description_file_url = '';
        this.$refs[`pdffile${index}`][0].reset();
        e.preventDefault();
        return;
      }
      if (!this.formData.tasks[index].description_file) {
        return;
      }
      this.$refs[`pdffile${index}`][0].reset();
      e.preventDefault();
    },
    changePdfFile(e, index) {
      if (!this.formData.tasks[index].description_file) {
        return null;
      }
      if (this.formData.tasks[index].description_file &&
          this.formData.tasks[index].description_file.size > 5000000) {
        this.$refs[`pdffile${index}`][0].reset();
        this.alertError.text = 'Maximum allowed file size is 5 MB.';
        this.alertError.visible = true;
      }
      return null;
    },
    calculateImagesCount() {
      let result = 0;
      if (this.formData.picture) {
        console.log('this.formData.picture');
        result++;
      }
      for (let i = 0; i < this.formData.tasks.length; i++) {
        if (this.formData.tasks[i].picture) result++;
        if (this.formData.tasks[i].description_file) result++;
        result += this.formData.tasks[i].steps.filter(item => item.picture).length;
      }
      console.log('calculateImagesCount', result);
      return result;
    },
    uploadVideo(data) {
      const uploadData = {
        filename: data.name,
      }
      if (this.$route.params.companyId) {
        uploadData.company = this.$route.params.companyId;
      }
      return this.$http.post('upload/', uploadData,
        {
          method: 'POST',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          return axios.put(response.body.upload_url, data,
            {
              method: 'PUT',
              headers: axios.defaults.headers.common,
              // {
              //   'content-type': 'video/mp4',
              // },
              // emulateJSON: true,
            })
            .then((resp) => {
              if (response.status !== 200) {
                this.alertError.text = this.getErrorText(resp);
                return resp.status;
              }
              return response.body.final_url;
            })
            .catch((response) => {
              if (response.status === 401) {
                this.onLogout();
              }
              this.alertError.text = this.getErrorText(response);
              return response;
            });
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    saveChecklistItemVideo(item) {
      if (!item.video || item.selectedContent !== 'video') {
        return new Promise((resolve) => {
          resolve(false);
        });
      }
      return this.uploadVideo(item.video)
      .then((urlVideo) => {
        console.log('uploadUrlVideo', urlVideo);
        item.video_url = urlVideo;
        return null;
      });
    },
    // duplicateChecklist() {
    //   this.$router.push({ name: this.$route.name.replace('Change', 'Duplicate') });
    //   location.reload();
    //   // this.$router.go(this.$router.currentRoute);
    // },
    duplicateChecklist() {
      return this.$http.post(`checklist-templates/${this.checklistId}/duplicate/`, {},
        {
          method: 'POST',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('checklist duplication err', response);
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          console.log('DUPLICATE RESPONSE', response );
          this.$router.push({ name: 'Checklist Configuration Change',
            params: { checklistId: response.body.id } });
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    saveChecklist() {
      const self = this;
      if (!this.validateChecklist()) {
        this.alertError.visible = true;
        return;
      }
      this.hasSaveError = false;
      // return;
      this.upload.total = this.calculateImagesCount();
      this.upload.uploaded = 0;
      this.upload.image = (this.upload.total !== 0);
      this.upload.visible = true;
      this.sendSaveChecklistTemplate(self.formData)
        .then((response) => {
          if (response !== 200 && response !== 201) {
            self.hasSaveError = true;
            console.log('sendSaveChecklistTemplate err', response);
          } else
            this.needFill = false;
            if (self.duplicate) {
              setTimeout(() => {
                this.$router.push({
                  name: this.$route.name.replace('Duplicate', 'Change'),
                  params: {
                    companyId: this.$route.params.companyId,
                    checklistId: this.formData.id,
                  },
                });
              }, 3000);
            }
        })
        .then(() => self.saveTasks(self.formData.tasks))
        .then(() => {
          self.haveItemChanges = false;
          if (self.formData.tasks.length) {
            self.deleteTaskSteps(self.formData.tasks[self.activeTask]);
          }
        })
        .then(() => {
          if (self.hasSaveError) {
            console.log('saveEnd save has errors');
            self.alertError.text = 'There were errors during the upload';
            self.alertError.visible = true;
            this.upload.visible = false;
          } else {
            console.log('saveEnd success');
            self.alertSuccess.visible = true;
            this.upload.visible = false;
            setTimeout(() => { self.$router.push({ name: 'Checklists' }); }, 3000);
          }
        })
        .catch((response) => {
          console.log('ERRR have catch', response);
          self.alertError.text = 'There were errors during the upload';
          self.alertError.visible = true;
          this.upload.visible = false;
        });
    },
    deleteChecklist() {
      const self = this;
      if (this.formData.id) {
        this.sendDeleteChecklist(this.formData.id)
          .then(() => {
            self.alertSuccess.text = 'Checklist successfully deleted';
            self.alertSuccess.title = 'Well done!';
            self.alertSuccess.visible = true;
            setTimeout(() => { self.$router.push({ name: 'Checklists' }); }, 3000);
          });
      }
    },
    sendDeleteChecklist(id) {
      return this.$http.patch(`checklist-templates/${id}/`, { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('checklist del err', response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    deleteTask(task, index) {
      if (task.id) {
        this.sendDeleteTask(task);
      }
      this.formData.tasks.splice(index, 1);
      this.haveItemChanges = false;
    },
    sendDeleteTask(task) {
      return this.$http.patch(`task-templates/${task.id}/`, { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('task del err', response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    saveTasks(tasks) {
      let count = 0;
      const self = this;
      function saveTask(task, resolve) {
        self.saveChecklistItemVideo(task)
        .then(() => self.sendSaveTask(task))
          .then((response) => {
            if (response !== 201 && response !== 200) {
              console.log('sendSavetasks has err', response);
              self.hasSaveError = true;
            } else {
              return self.saveTaskSteps(task.steps, task.id);
            }
            return null;
          })
          .then(() => {
            count++;
            if (count === tasks.length) {
              self.sendUpdateChecklistTasks(self.formData);
              resolve();
            }
          })
          .catch(() => {
            self.hasSaveError = true;
            count++;
            if (count === tasks.length) {
              self.sendUpdateChecklistTasks(self.formData);
              resolve();
            }
          });
      }
      return new Promise((resolve) => {
        if (!tasks.length) resolve();
        for (let i = 0; i < tasks.length; i++) {
          saveTask(tasks[i], resolve);
        }
      });
    },
    saveTask(task) {
      const self = this;
      this.alertError.text = ''
      if (!this.validateTask(task)) {
        this.alertError.visible = true;
        if (!this.alertError.text) {
          this.alertError.text = 'Missing needed data. All basic info fields and at least one checklist item are mandatory.';
        }
        this.activeTaskNext = null;
        return;
      }
      self.hasSaveError = false;
      this.upload.total = task.steps.filter(item => item.picture).length;
      this.upload.total += task.description_file ? 1 : 0;
      this.upload.uploaded = 0;
      this.upload.image = (this.upload.total !== 0);
      this.upload.visible = true;
      self.saveChecklistItemVideo(task)
      .then(() => self.sendSaveTask(task))
        .then((response) => {
          if (response !== 200 && response !== 201) {
            self.hasSaveError = true;
            console.log('saveTask err', response);
          } else {
            return self.saveTaskSteps(task.steps, task.id);
          }
          return null;
        })
        .then(() => self.deleteTaskSteps(task))
        .then(() => {
          if (self.hasSaveError) return null;
          return this.sendUpdateChecklistTasks(self.formData);
        })
        .then(() => {
          if (self.hasSaveError) {
            console.log('saveEnd save has errors');
            self.alertError.text = 'There were errors during the upload';
            self.alertError.visible = true;
            self.upload.visible = false;
            this.activeTaskNext = null;
          } else {
            console.log('saveEnd success');
            self.alertSuccess.visible = true;
            self.upload.visible = false;
            self.haveItemChanges = false;
            if (this.activeTaskNext !== null) {
              this.activeTask = this.activeTaskNext;
            }
          }
        })
        .catch((response) => {
          console.log('ERRR have catch', response);
          self.alertError.text = 'There were errors during the upload';
          self.alertError.visible = true;
          self.upload.visible = false;
          this.activeTaskNext = null;
        });
    },
    saveTaskSteps(steps, taskId) {
      const self = this;
      if (!steps.length) {
        return null;
      }
      return new Promise((resolve) => {
        let count = 0;
        for (let i = 0; i < steps.length; i++) {
          self.saveChecklistItemVideo(steps[i])
          .then(() => self.sendSaveStep(steps[i], taskId))
            .then((response) => {
              if (response !== 201 && response !== 200) {
                console.log('sendSaveStep has err', response);
                self.hasSaveError = true;
              }
              count++;
              if (count === steps.length) {
                resolve();
              }
            })
            .catch((response) => {
              self.alertError.text = self.getErrorText(response);
              return response;
            });
        }
      });
    },
    sendUpdateChecklistPicture(checklist) {
      if (checklist.id) {
        if (!checklist.picture && checklist.picture_url) {
          return 200;
        }
        const formData = new FormData();
        formData.append('picture', checklist.picture);
        // Deprecated
        // if (this.duplicate) {
        //   if (checklist.picture) {
        //     let blob = new Blob([checklist.picture], { type: 'image/jpeg' });
        //     // let fileOfBlob = new File([blob], 'photo.jpg', { type: 'image/jpeg' });
        //     // form.append("upload", fileOfBlob);
        //     // formData.append('picture', fileOfBlob);
        //     formData.append('picture', blob, 'photo.jpg');
        //   }
        // } else {
        //   formData.append('picture', checklist.picture);
        // }
        return this.$http.patch(`checklist-templates/${checklist.id}/`, formData,
          {
            method: 'PATCH',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
          })
          .then((response) => {
            if (response.status !== 200) {
              console.log('checklist err', response);
              return response.status;
            }
            if (checklist.picture) this.upload.uploaded++;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            this.alertError.text = this.getErrorText(response);
            return response;
          });
      }
      return null;
    },
    discardTaskChanges(taskIndex) {
      if (!this.formData.tasks[taskIndex].id) {
        Object.assign(this.formData.tasks[taskIndex], this.emptyTask);
        this.formData.tasks[taskIndex].steps = [];
        this.haveItemChanges = false;
        if (this.activeTaskNext !== null) {
          this.activeTask = this.activeTaskNext;
        }
        return;
      }
      for (let i = 0; i < this.checklist.tasks.length; i++) {
        if (this.checklist.tasks[i].id !== this.formData.tasks[taskIndex].id) {
          continue;
        }
        const task = this.formData.tasks[taskIndex];
        task.id = this.checklist.tasks[i].id;
        task.name = this.checklist.tasks[i].name;
        task.description = this.checklist.tasks[i].description;
        task.description_file = '';
        task.description_file_url = this.checklist.tasks[i].description_file;
        task.picture = '';
        task.picture_url = this.checklist.tasks[i].picture;
        task.index = this.checklist.tasks[i].index;
        task.steps = [];
        for (let j = 0; j < this.checklist.tasks[i].steps.length; j++) {
          this.addEmptyStep(task);
          task.steps[j].id = this.checklist.tasks[i].steps[j].id;
          task.steps[j].description = this.checklist.tasks[i].steps[j].description;
          task.steps[j].order = this.checklist.tasks[i].steps[j].index;
          task.steps[j].picture = '';
          task.steps[j].picture_url = this.checklist.tasks[i].steps[j].picture;
        }
      }
      this.haveItemChanges = false;
      if (this.activeTaskNext !== null) {
        this.activeTask = this.activeTaskNext;
      }
    },
    getCompany() {
      function assignDefaultRoles() {
        this.userRoles.push({
          name: 'Basic user',
          id: 'basic',
        });
        this.userRoles.push({
          name: 'Shift leader',
          id: 'shift_leader',
        });
        this.userRoles.push({
          name: 'Manager',
          id: 'manager',
        });
      }
      let id = null;
      if (this.authUser && this.authUser.company && this.authUser.company.id) {
        id = this.authUser.company.id;
      }
      if (this.$route.params.companyId) {
        id = this.$route.params.companyId;
      }
      if (!id) {
        assignDefaultRoles();
        return null;
      }
      return this.$http.get(`companies/${id}/`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            assignDefaultRoles();
            return response.status;
          }
          this.userRoles = [];
          console.log('response body companies', response.body);
          this.userRoles.push({
            name: response.body.basic_role_display_name || 'Basic user',
            id: 'basic',
          });
          this.userRoles.push({
            name: response.body.shift_leader_role_display_name || 'Shift leader',
            id: 'shift_leader',
          });
          this.userRoles.push({
            name: response.body.manager_role_display_name || 'Manager',
            id: 'manager',
          });
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });;
    },
    sendUpdateChecklistTasks(checklist) {
      if (!checklist.id) return null;
      const data = { tasks: [] };
      let index = 1;
      for (let i = 0; i < checklist.tasks.length; i++) {
        if (checklist.tasks[i].id) {
          data.tasks.push(checklist.tasks[i].id);
          checklist.tasks[i].index = index++;
        }
      }
      return this.$http.patch(`checklist-templates/${checklist.id}/`, data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('checklist err', response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    sendSaveChecklistTemplate(checklist) {
      const self = this;
      const data = {
        name: checklist.name,
        area: (checklist.area.length) ? checklist.area[0].id : null,
        double_signature_required: checklist.double_signature_required,
        role: checklist.role,
        // picture: checklist.picture,
        tasks: [],
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      let index = 1;
      for (let i = 0; i < checklist.tasks.length; i++) {
        if (checklist.tasks[i].id) {
          data.tasks.push(checklist.tasks[i].id);
          checklist.tasks[i].index = index++;
        }
      }
      if (!checklist.id) {
        return this.$http.post('checklist-templates/', data,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('checklist err', response);
              return response.status;
            }
            checklist.id = response.body.id;
            return self.sendUpdateChecklistPicture(checklist);
          })
          .catch((response) => {
            if (response.status === 401) {
              self.onLogout();
            }
            self.alertError.text = self.getErrorText(response);
            return response;
          });
      }
      if (checklist.picture_url && !checklist.picture) delete data.picture;
      return this.$http.patch(`checklist-templates/${checklist.id}/`, data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('checklist err', response);
            return response.status;
          }
          return self.sendUpdateChecklistPicture(checklist);
        })
        .catch((response) => {
          if (response.status === 401) {
            self.onLogout();
          }
          self.alertError.text = self.getErrorText(response);
          return response;
        });
    },
    sendSaveTask(task) {
      const data = {
        type: 'checklist',
        name: task.name,
        description: task.description,
        description_file: task.description_file,
        picture: (task.selectedContent === 'image') ? task.picture : '',
        video: (task.selectedContent === 'video' && task.video_url) ? task.video_url : '',
        video_thumbnail: (task.selectedContent === 'video' && task.video_url) ? task.video_thumbnail : '',
        index: task.index,
      };
      if (this.$route.params.companyId) {
        data.company = this.$route.params.companyId;
      }
      if (!task.id) {
        const formData = new FormData();
        for (const key in data) {
          formData.append(key, data[key]);
        }
        return this.$http.post('task-templates/', formData,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('task err', response);
              return response.status;
            }
            task.id = response.body.id;
            if (data.picture) this.upload.uploaded++;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            this.alertError.text = this.getErrorText(response);
            return response;
          });
      }
      if (task.picture_url && !task.picture) delete data.picture;
      if (task.description_file_url && !task.description_file) delete data.description_file;
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      return this.$http.patch(`task-templates/${task.id}/`, formData,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('task err', response);
            return response.status;
          }
          if (data.picture) this.upload.uploaded++;
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    sendSaveStep(step, taskId) {
      const data = {
        description: step.description,
        picture: (step.selectedContent === 'image') ? step.picture : '',
        video: (step.selectedContent === 'video' && step.video_url) ? step.video_url : '',
        video_thumbnail: (step.selectedContent === 'video' && step.video_url) ? step.video_thumbnail : '',
        index: step.order,
        template: taskId,
      };
      if (!step.id) {
        const formData = new FormData();
        for (const key in data) {
          formData.append(key, data[key]);
        }
        return this.$http.post('task-steps/', formData,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log('task step err', response);
              return response.status;
            }
            step.id = response.body.id;
            if (data.picture) this.upload.uploaded++;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            this.alertError.text = this.getErrorText(response);
            return response;
          });
      }
      if (step.picture_url && !step.picture) delete data.picture;
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      return this.$http.patch(`task-steps/${step.id}/`, formData,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('task step err', response);
            return response.status;
          }
          if (data.picture) this.upload.uploaded++;
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    deleteTaskSteps(task) {
      const self = this;
      return new Promise((resolve) => {
        if (!task.stepsMustDelete.length) return resolve();
        let count = 0;
        for (let i = 0; i < task.stepsMustDelete.length; i++) {
          self.sendDeleteTaskStep(task.stepsMustDelete[i])
            .then((response) => {
              if (response.status !== 200) {
                console.log('sendDeleteTaskStep has err', response);
                self.hasSaveError = true;
              }
              count++;
              if (count === task.stepsMustDelete.length) {
                task.stepsMustDelete = [];
                resolve();
              }
            });
        }
        return null;
      });
    },
    sendDeleteTaskStep(stepId) {
      return this.$http.patch(`task-steps/${stepId}/`, { is_active: false },
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log('DELETE step err ', response);
            return response;
          }
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          return response;
        });
    },
    getChecklist(id) {
      this.$http.get(`checklist-templates/${id}/`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return;
          }
          this.checklist = response.body;
          this.fillAllData();
          this.processLoading = false;

          // return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getWorkingAreas() {
      let url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return;
          }
          this.areas = response.body;
          // return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    getAreaById(id, area = this.areas) {
      for (let i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        const res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },
    downloadImage(url) {
      return axios.get(url, {
        headers: axios.defaults.headers.common,
        responseType: 'arraybuffer',
      })
      .then((resp) => {
        if (resp.status !== 200) {
          return null;
        }
        return resp.data;
      })
      .catch((response) => {
        console.log('download complite error', response);
        if (response.status === 401) {
          this.onLogout();
        }
        this.alertError.text = this.getErrorText(response);
        return null;
      });
    },
    fillAllData() {
      if (!this.checklist) return;
      this.formData.id = this.checklistId;
      // Deprecated
      // if (this.duplicate) this.formData.id = 0;
      this.formData.name = this.checklist.name;
      this.formData.role = this.checklist.role;
      this.formData.area = (this.checklist.area && this.areas.length) ?
        [this.getAreaById(this.checklist.area)] : [];
      this.formData.double_signature_required = this.checklist.double_signature_required;
      this.formData.picture_url = this.checklist.picture;
      // Depecated
      // if (this.duplicate) {
      //   if (this.formData.picture_url) {
      //     this.downloadImage(this.formData.picture_url)
      //     .then((resp) => {
      //       if (resp) {
      //         this.formData.picture = resp;
      //       }
      //     })
      //     .catch((resp) => {
      //       console.log('err', resp);
      //     });
      //   }
      // }
      this.formData.tasks = [];
      for (let i = 0; i < this.checklist.tasks.length; i++) {
        // Deprecated
        // if (this.duplicate) continue;
        this.addEmptyTask();
        const task = this.formData.tasks[i];
        task.id = this.checklist.tasks[i].id;
        task.name = this.checklist.tasks[i].name;
        task.description = this.checklist.tasks[i].description;
        task.description_file_url = this.checklist.tasks[i].description_file;
        task.picture_url = this.checklist.tasks[i].picture;
        task.thumbnail_url = (this.checklist.tasks[i].video_thumbnail);
        task.video_url = (this.checklist.tasks[i].video);
        if (task.picture_url) {
          task.selectedContent = 'image';
        }
        if (task.video_url) {
          task.picture_url = '';
          task.selectedContent = 'video';
        }
        task.index = this.checklist.tasks[i].index;
        task.steps = [];
        for (let j = 0; j < this.checklist.tasks[i].steps.length; j++) {
          this.addEmptyStep(task);
          task.steps[j].id = this.checklist.tasks[i].steps[j].id;
          task.steps[j].description = this.checklist.tasks[i].steps[j].description;
          task.steps[j].order = this.checklist.tasks[i].steps[j].index;
          task.steps[j].picture_url = this.checklist.tasks[i].steps[j].picture;
          task.steps[j].thumbnail_url = (this.checklist.tasks[i].steps[j].video_thumbnail);
          task.steps[j].video_url = (this.checklist.tasks[i].steps[j].video);
          if (task.steps[j].picture_url) {
            task.steps[j].selectedContent = 'image';
          }
          if (task.steps[j].video_url) {
            task.steps[j].picture_url = '';
            task.steps[j].selectedContent = 'video';
          }
        }
      }
      this.haveItemChanges = false;
    },
    validateSteps(task) {
      for (let i = 0; i < task.steps.length; i++) {
        task.steps[i].valid = true;
      }
      for (let i = 0; i < task.steps.length; i++) {
        const currentOrder = +task.steps[i].order;
        for (let j = i + 1; j < task.steps.length; j++) {
          if (task.steps[j].order === currentOrder) {
            task.steps[i].valid = false;
            task.steps[j].valid = false;
          }
        }
      }
    },
    validateChecklist() {
      this.alertError.title = 'Error!';
      this.alertError.text = 'Missing needed data. All basic info fields and at least one checklist item are mandatory.';
      this.needFill = true;
      if (!this.formData.name) {
        this.alertError.text = 'Please fill field "Title"';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.role) {
        this.alertError.text = 'Please select role';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.area.length) {
        this.alertError.text = 'Please select working area';
        this.alertError.visible = true;
        return false;
      }
      let tasksIsValid = true;
      for (let i = 0; i < this.formData.tasks.length; i++) {
        tasksIsValid = tasksIsValid && this.validateTask(this.formData.tasks[i]);
      }
      return tasksIsValid;
      // return true;
    },
    validateTask(task) {
      if (!task.name) {
        this.alertError.text = 'Please fill checklist item title';
        return false;
      }
      // if (!task.description) {
      //   this.alertError.text = 'Please fill checklist item description';
      //   return false;
      // }
      task.video_require = false;
      if (task.selectedContent === 'video' &&
          ((task.video_thumbnail || task.thumbnail_url) &&
            !(task.video || task.video_url))) {
        task.video_require = true;
        this.alertError.text = 'Please add video file';
        this.alertError.visible = true;
        return false;
      }
      if (task.selectedContent === 'video' &&
          (!(task.video_thumbnail || task.thumbnail_url) &&
            (task.video || task.video_url))) {
        task.video_require = true;
        this.alertError.text = 'Please add thumbnail image';
        this.alertError.visible = true;
        return false;
      }
      if (!task.description_file) {
        for (let i = 0; i < task.steps.length; i++) {
          // if (!task.steps[i].description) {
          //   this.alertError.text = 'Please fill checklist item step description';
          //   return false;
          // }
          if (!task.steps[i].valid) {
            this.alertError.text = 'Please correct instructions for the checklist item';
            return false;
          }
        }
      }
      for (let i = 0; i < task.steps.length; i++) {
        const step = task.steps[i];
        step.video_require = false;
        if (step.selectedContent === 'video' &&
            ((step.video_thumbnail || step.thumbnail_url) &&
              !(step.video || step.video_url))) {
          step.video_require = true;
          this.alertError.text = 'Please add video file';
          this.alertError.visible = true;
          return false;
        }
        if (step.selectedContent === 'video' &&
            (!(step.video_thumbnail || step.thumbnail_url) &&
              (step.video || step.video_url))) {
          step.video_require = true;
          this.alertError.text = 'Please add thumbnail image';
          this.alertError.visible = true;
          return false;
        }
      }
      return true;
    },
    handleDragStart(e, item, index) {
      e.target.style.opacity = '0.4';
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text', index.toString());
      this.dragSrcEl = index;
    },
    handleDragEnd(e) {
      e.target.style.opacity = '';
    },
    handleDrop(e, index) {
      console.log('handleDrop()', index);
      if (e.stopPropagation) {
        e.stopPropagation(); // Stops some browsers from redirecting.
      }
      // Don't do anything if dropping the same column we're dragging.
      if (this.dragSrcEl !== index) {
        this.dragSrcEl = index;
        index = e.dataTransfer.getData('text');
        if (index < this.dragSrcEl) {
          this.formData.tasks.splice(+this.dragSrcEl + 1, 0, this.formData.tasks[index]);
          this.formData.tasks.splice(index, 1);
        } else {
          this.formData.tasks.splice(+this.dragSrcEl, 0, this.formData.tasks[index]);
          this.formData.tasks.splice(+index + 1, 1);
        }
        if (this.activeTask === +this.dragSrcEl) {
          if (this.haveItemChanges) {
            this.activeTask = +index;
            this.$refs.leavingItemConfirm.show();
          }
        } else {
          this.activeTask = +this.dragSrcEl;
        }
      }
      return false;
    },
    handleDragOver(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }
    },
    getErrorText(response) {
      const result = `There were errors during the upload (${response.status})`;
      if (response.status === 400) {
        if (!response.body) {
          return 'Large file';
        }
        for (const key in response.body) {
          return `${key}: ${response.body[key]}`;
        }
      }
      if (response.status === 401) {
        return 'Invalid authorization, please relogin';
      }
      if (response.status === 404) {
        return 'Not found (404)';
      }
      if (response.status === 500) {
        return 'Internal server error';
      }
      return result;
    },
    onChangeChecklistTask() {
      this.haveItemChanges = true;
    },
  },
  computed: {},
  created() {
    // this.createUserRoles();
    this.getCompany();
    // this.addEmptyTask();
    this.getWorkingAreas();
    this.checklistId = this.$route.params.checklistId;
    if (this.checklistId) {
      this.processLoading = true;
      this.getChecklist(this.checklistId);
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'Checklist Configuration Change' || to.name === 'Checklist Configuration Change SuperUser') {
        this.processLoading = true;
        this.checklistId = to.params.checklistId;
        this.formData.id = to.params.checklistId;
        this.getChecklist(to.params.checklistId);
      }
    },
    areas() {
      this.updateSuggestArea();
      if (this.checklist) {
        this.formData.area = (this.checklist.area && this.areas.length) ?
          [this.getAreaById(this.checklist.area)] : [];
      }
    },
    activeTaskNext(val, prev) {
      if (val === null || val === this.activeTask) return;
      if (this.haveItemChanges && val !== null) {
        this.$refs.leavingItemConfirm.show();
      } else {
        this.activeTask = val;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/checklistConfig/checklistConfig.component.js